import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import Notify from "lib/Utils/Alert";
import { Button } from "reactstrap";

import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { Checkbox, Radio, RadioGroup } from "@mui/material";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}



function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
export default function PurchaserNotification({
  purchaser,
  setSelectedRadio,
  selectedRadio,
  contactType,
  onDatataClick,
  token,
  onModalCliclk,
  customeEmail,
  onDatataClickFunc,
  isOpen,
  contacts,
}) {
  const [selected, setSelected] = React.useState("");
  const [selected1, setSelected1] = React.useState("");
  const [selected2, setSelected2] = React.useState("");
  const [selected3, setSelected3] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = useState({});
  const [selectCard, setSelectedCard] = useState("");
  const [radioValue, setRadioValue] = useState(false);
  const [id, setId] = useState();
  const [selectedRows, setSelectedRows] = useState({
    orderConfirmation: null,
    proformaInvoice: null,
    orderInvoice: null,
  });

  const handleClick = (row, email, index) => {
    if (selected == email) {
      setSelected("")
      onDatataClickFunc("")
    } else {
      setSelected(email);

    }
  };
  const handleClick1 = (row, email, index) => {
    if (selected1 == email) {
      setSelected1("")
      onDatataClickFunc("")
    } else {
      setSelected1(email);
    }
  };
  const handleClick2 = (row, email, index) => {
    if (selected2 == email) {
      setSelected2("")
      onDatataClickFunc("")
    } else {
      setSelected2(email);
    }
  };
  const handleClick3 = (row, email, index) => {
    if (selected3 == email) {
      setSelected3("")
      onDatataClickFunc("")
    } else {
      setSelected3(email);
    }
  };

  const handleRadio = (e) => {
    setRadioValue(e.target.checked)
  }

  useEffect(() => {
    if (isOpen == true) {
      setSelected("");
    }
  }, [isOpen]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };



  const isSelected = (email) => selectedRadio?.cardDelivery?.some(item => item.email === email);
  const isSelected1 =(email) => selectedRadio?.orderConfirmation?.some(item => item.email === email);
  const isSelected2 =(email) => selectedRadio?.proformaInvoice?.some(item => item.email === email);
  const isSelected3 =(email) => selectedRadio?.orderInvoice?.some(item => item.email === email);

  useEffect(() => {
    let data = contacts?.filter((e) => e?.cardDelivery);
    setSelected(data[0]?.email);
    let data1 = contacts?.filter((e) => e?.orderConfirmation);
    setSelected1(data1[0]?.email);
    let data2 = contacts?.filter((e) => e?.proformaInvoice);
    setSelected2(data2[0]?.email);
    let data3 = contacts?.filter((e) => e?.orderInvoice);
    setSelected3(data3[0]?.email);
  }, [contacts]);




  const handleRadioChange = (e, row) => {
    const { name, checked } = e.target;

    setSelectedRadio(prevState => {
      let currentArray = prevState[name] || [];
      let index = currentArray.findIndex(item => item.email === row?.email);

      if (checked && index === -1) {
        currentArray.push({ email: row?.email, value: true });
      } else if (!checked && index !== -1) {
        currentArray.splice(index, 1);
      }

      return {
        ...prevState,
        [name]: currentArray
      };
    });
  };

  return (
    <Box sx={{ width: "100%" }}>


      <Paper sx={{ width: "100%", mb: 2 }}>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            {/* <TableHead> */}
            <TableRow>
              {/* <StyledTableCell></StyledTableCell> */}
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Card Delivery</StyledTableCell>
              <StyledTableCell>Order Confirmation</StyledTableCell>
              <StyledTableCell>Proforma Invoice</StyledTableCell>
              <StyledTableCell>Order Invoice</StyledTableCell>


            </TableRow>

            <TableBody>
              {contacts?.map((row, index) => {
              
                const isItemSelected = isSelected(row.email, index);
                  const isItemSelected1 = isSelected1(row.email, index);
                  const isItemSelected2 = isSelected2(row.email, index);
                  const isItemSelected3 = isSelected3(row.email, index);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <StyledTableRow
                    hover
                    // onClick={(event) => handleClick(row, row.email,index)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.email}
                    selected={isItemSelected}
                    sx={{ cursor: "pointer" }}
                  >
                    <StyledTableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="none"
                    >
                      {row.email}
                    </StyledTableCell>

                    <StyledTableCell
                      padding="checkbox"
                      component="th"
                      // onClick={(event) => handleClick(row, row.email,index)}
                      id={labelId}
                      scope="row"
                    >
                      <span onClick={() => handleClick(row, row.email, index)}>
                        <Checkbox
                          color="primary"
                          onChange={(e) => handleRadioChange(e, row)}
                          name={'cardDelivery'}
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </span>
                    </StyledTableCell>
                    <StyledTableCell
                      padding="checkbox"
                      component="th"
                      // onClick={(event) => handleClick1(row, row.email,index)}
                      id={labelId}
                      scope="row"
                    >
                      <span onClick={() => handleClick1(row, row.email, index)}>
                        <Checkbox
                          color="primary"
                          onChange={(e) => handleRadioChange(e, row)}
                          name={'orderConfirmation'}
                          checked={isItemSelected1}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </span>
                    </StyledTableCell>
                    <StyledTableCell
                      padding="checkbox"
                      component="th"
                      // onClick={(event) => handleClick2(row, row.email,index)}
                      id={labelId}
                      scope="row"
                    >
                      <span onClick={() => handleClick2(row, row.email, index)}>
                        <Checkbox
                          color="primary"
                          onChange={(e) => handleRadioChange(e, row)}
                          name={'proformaInvoice'}
                          checked={isItemSelected2}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </span>
                    </StyledTableCell>
                    <StyledTableCell
                      padding="checkbox"
                      component="th"
                      id={labelId}
                      // onClick={(event) => handleClick3(row, row.email,index)}
                      scope="row"
                    >
                      <span onClick={() => handleClick3(row, row.email, index)}>
                        <Checkbox
                          color="primary"
                          onChange={(e) => handleRadioChange(e, row)}
                          name={'orderInvoice'}
                          checked={isItemSelected3}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </span>
                    </StyledTableCell>


                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={contacts.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}

      </Paper>


    </Box>
  );
}
